import { selectCurrentHotelName, selectLoggedinUserName } from 'accessors'
import SavibookHeader from 'components/ReusableComponents/Savibook/Header'
import SavibookHero from 'components/ReusableComponents/Savibook/Hero'
import RibbonBanner from 'components/ReusableComponents/Savibook/RibbonBanner'
import { useSelector } from 'react-redux'

function PromoPreview({ promoTagline }) {
  const userName = useSelector(selectLoggedinUserName)
  const hotelName = useSelector(selectCurrentHotelName)
  const isDemoMode = useSelector(s => s.login.isDemoMode)

  return (
    <SavibookHero lightbg>
      <SavibookHeader text={isDemoMode ? 'The Luxury Resort & Spa' : hotelName} />
      <RibbonBanner
        topText={`${userName.replace(/ .*/, '')}, you unlocked`}
        mainText={promoTagline}
      />
    </SavibookHero>
  )
}

export default PromoPreview
